<template>
    <div>
        <div class="form-horizontal">
            <form-input :form="form" property="used">
                <input type="checkbox" v-model="form.used">
            </form-input>

            <form-input :form="form" property="email"></form-input>
            <form-input :form="form" property="stripe_invoice_id"></form-input>
            <form-input :form="form" property="code"></form-input>
            <form-input :form="form" property="deal"></form-input>
            <form-input :form="form" property="user_id"></form-input>
        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';

export default {
    mixins: [Model],
    data() {
        return {
            active: 'form',
            method: '/api/ltds',
            form: new Form(() => {
                return {
                    used: null,
                    email: null,
                    stripe_invoice_id: null,
                    code: null,
                    deal: null,
                    user_id: null,
                };
            })
        };
    },
    methods: {

    },
    computed: {

    },
    mounted() {
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/Ltd.vue